import { Box } from '@mui/material';
import { SocialListeningBrandMentionCard } from 'features/socialListeningCommunity/components';
import { SocialListeningCommunityCard } from 'features/socialListeningCommunity/components/community';
import { SocialListeningProductsCard } from 'features/socialListeningCommunity/components/products';

interface Props {
  brandId: string;
}

export const SocialListeningCommunitySummaryView = ({ brandId }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 4,
        flexWrap: 'wrap',
        flex: 1,
      }}
    >
      <SocialListeningBrandMentionCard brandId={brandId} />
      <SocialListeningCommunityCard brandId={brandId} />
      {/* TODO: Add back in when BE is ready */}
      {/* <SocialListeningProductsCard brandId={brandId} /> */}
    </Box>
  );
};
